import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { API_HOST, authenticatedFetchData } from '../../../../lib'
import { logError } from '@tomra/datadog-browser-logging'
import { Dialog } from '../../../common/Dialog'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  email: string
  userId: string
  appContext: string
  onClose: () => void
}

export const SendPasswordDialog = ({ email, userId, appContext, onClose }: Props) => {
  const [status, setStatus] = useState<RequestStatusType>('idle')
  const [password] = useState(uuidv4().substring(0, 8))

  const enablePasswordLogin = async () => {
    setStatus('pending')

    try {
      await authenticatedFetchData(`${API_HOST}/mytomra/v1.0/hotlinetool/enable-user-password`, {
        method: 'POST',
        body: JSON.stringify({
          userId,
          password
        })
      }).run()
      setStatus('success')
    } catch (error: any) {
      setStatus('failure')
      logError(new Error('Failed to set password login on user'), error)
    }
  }

  return (
    <>
      <Dialog ariaLabel={`Changes ${status}`} onClose={onClose}>
        <div className="rounded-2xl bg-white shadow-md dark:bg-gray-900 p-6 flex flex-col gap-y-4 pt-9 max-w-300">
          <h1 className="text-xl">Set user password</h1>

          {status === 'idle' ? (
            <>
              <p>
                When logging into {appContext}, the user can either receive an email login link or type in the new
                password once it has been set.
              </p>
              <p>Password will be set for the following user:</p>

              <p>
                <b>{email}</b>
              </p>

              <p>Are you sure? Once set, the user can&apos;t go back to email link based authentication.</p>
            </>
          ) : status === 'success' ? (
            <div>
              <p>The following password was set on the user:</p>

              <p className="p-4 mt-4 border-2 rounded-lg bg-gray-100 text-center text-lg">
                <b className="max-w-300 break-words text-emerald-700">{password}</b>
              </p>
            </div>
          ) : null}

          {status === 'failure' && (
            <div className="rounded-lg border-l-[3px] border-rose-500 bg-white p-4 text-left shadow-md dark:bg-gray-900">
              Whoopsie! Something went wrong.
            </div>
          )}

          {status !== 'success' && (
            <Button onClick={() => enablePasswordLogin()} variant="primary" className="ml-auto">
              {status === 'pending' ? <div className="loadingSpinner" /> : 'Continue'}
            </Button>
          )}
        </div>
      </Dialog>
    </>
  )
}
